// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"38":"1bb74351","427":"226ae98f"}[chunkId] + ".js";
};